var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup31(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    width: 184.219,
    height: 124.051,
    viewBox: "0 0 184.219 124.051",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_31",
    "data-name": "Group 31",
    transform: "translate(-1871.906 -1326.447)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M3102.26,369.885a21.586,21.586,0,1,1-21.586-21.586,21.58,21.58,0,0,1,21.586,21.586",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M3058.308,398.027a15.273,15.273,0,0,1,1.924,7.434v39.058h-11.125v-34.93a11.844,11.844,0,0,1,9.2-11.562",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M3112.251,409.589V444.52h-45.022V405.461a21.95,21.95,0,0,0-1.4-7.749h34.546a11.876,11.876,0,0,1,11.876,11.877",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M2981.191,369.885A21.586,21.586,0,1,1,2959.6,348.3a21.58,21.58,0,0,1,21.586,21.586",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    d: "M2939.908,397.712h33.321a21.993,21.993,0,0,0-1.4,7.749v39.058h-43.8v-34.93a11.876,11.876,0,0,1,11.876-11.877",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M2991.176,409.589V444.52h-12.35V405.461a15.117,15.117,0,0,1,2.048-7.626,11.845,11.845,0,0,1,10.3,11.754",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M3047.358,354.28a27.829,27.829,0,1,1-27.829-27.829,27.822,27.822,0,0,1,27.829,27.829",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M3047.358,354.28a27.829,27.829,0,1,1-27.829-27.829,27.822,27.822,0,0,1,27.829,27.829",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M3060.232,405.461V450.5h-81.406V405.461a15.126,15.126,0,0,1,2.047-7.626,15.278,15.278,0,0,1,13.259-7.679h50.795a15.3,15.3,0,0,1,15.3,15.3",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M3060.232,405.461V450.5h-81.406V405.461a15.126,15.126,0,0,1,2.047-7.626,15.278,15.278,0,0,1,13.259-7.679h50.795a15.3,15.3,0,0,1,15.3,15.3",
    transform: "translate(-1056.125 999.996)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup31);
export default __webpack_public_path__ + "static/media/Group 31.0cb0d17aeb975f888d0e05d52a7cf9d7.svg";
export { ForwardRef as ReactComponent };